function mountStripeBankAccountSetup(container, pushEventFn) {
  if (container._stripeInitialized) return;
  container._stripeInitialized = true;

  var meta = document.querySelector("meta[name='stripe-publishable-key']");
  var publishableKey = meta ? meta.getAttribute("content") : null;
  if (!publishableKey || typeof Stripe === "undefined") return;

  var clientSecret = container.dataset.clientSecret;
  if (!clientSecret) return;

  var stripe = Stripe(publishableKey);
  var elements = stripe.elements({
    clientSecret: clientSecret,
    appearance: { theme: "stripe" },
  });

  var paymentElementContainer = container.querySelector(
    "[data-stripe-bank-account-element]"
  );
  var submitButton = container.querySelector("[data-stripe-bank-account-submit]");
  var nicknameInput = container.querySelector("[data-stripe-bank-account-nickname]");
  var autopayInput = container.querySelector("[data-stripe-bank-account-autopay]");

  if (!paymentElementContainer || !submitButton || !nicknameInput) return;

  var billingDetails = {};
  if (container.dataset.defaultEmail) {
    billingDetails.email = container.dataset.defaultEmail;
  }
  if (container.dataset.defaultName) {
    billingDetails.name = container.dataset.defaultName;
  }

  var paymentElementOptions = {
    paymentMethodOrder: ["us_bank_account"],
  };

  if (Object.keys(billingDetails).length > 0) {
    paymentElementOptions.defaultValues = {
      billingDetails: billingDetails,
    };
  }

  var paymentElement = elements.create("payment", paymentElementOptions);
  paymentElement.mount(paymentElementContainer);

  submitButton.addEventListener("click", async function () {
    var nickname = nicknameInput.value.trim();
    if (!nickname) {
      nicknameInput.reportValidity();
      return;
    }

    submitButton.disabled = true;

    var submitResult = await elements.submit();
    if (submitResult.error) {
      alert(submitResult.error.message);
      submitButton.disabled = false;
      return;
    }

    var confirmResult = await stripe.confirmSetup({
      elements: elements,
      clientSecret: clientSecret,
      confirmParams: { return_url: window.location.href },
      redirect: "if_required",
    });

    if (confirmResult.error) {
      alert(confirmResult.error.message);
      submitButton.disabled = false;
      return;
    }

    var setupIntent = confirmResult.setupIntent;
    if (setupIntent && setupIntent.status === "succeeded") {
      pushEventFn({
        stripe_payment_method_id: setupIntent.payment_method,
        nickname: nickname,
        autopay: autopayInput ? autopayInput.checked : true,
      });
      return;
    }

    alert("Bank account setup was not completed.");
    submitButton.disabled = false;
  });
}

export function createHook() {
  return {
    mounted() {
      var self = this;
      mountStripeBankAccountSetup(this.el, function (params) {
        self.pushEventTo(self.el, "stripe_bank_account_saved", params);
      });
    },
    destroyed() {},
  };
}

export function mountOnPage() {
  function scan() {
    document
      .querySelectorAll("[data-stripe-bank-account-setup]")
      .forEach(function (el) {
        var postUrl = el.dataset.postUrl;
        if (!postUrl) return;

        mountStripeBankAccountSetup(el, function (params) {
          var csrfToken = document
            .querySelector("meta[name='csrf-token']")
            .getAttribute("content");

          fetch(postUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-csrf-token": csrfToken,
            },
            body: JSON.stringify(params),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              if (data.success) {
                window.location.href = data.redirect_url;
              } else {
                alert(data.error || "Failed to save bank account");
              }
            });
        });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
